module.exports = __webpack_public_path__ + "img/1566077982.b2247e68.jpg";